import { Box } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { ReactNode } from "react";
import { EditView } from "./EditModal";

export type SlideDirection = "forward" | "back";

/* 화면별 최소 높이 — absolute 슬라이드 시 컨테이너 높이 유지 */
const VIEW_MIN_HEIGHT: Record<EditView, string> = {
    MAIN: "480px",
    NICKNAME: "72px",
    BIO: "240px",
};

const slideVariants = {
    enter: (direction: SlideDirection) => ({
        x: direction === "forward" ? "100%" : "-100%",
    }),
    center: {
        x: 0,
    },
    exit: (direction: SlideDirection) => ({
        x: direction === "forward" ? "-100%" : "100%",
    }),
};

interface ViewTransitionProps {
    viewKey: EditView;
    direction: SlideDirection;
    children: ReactNode;
}

export default function ViewTransition({
    viewKey,
    direction,
    children,
}: ViewTransitionProps) {
    return (
        <Box
            overflow="hidden"
            position="relative"
            minHeight={VIEW_MIN_HEIGHT[viewKey]}
            transition="min-height 0.28s ease"
        >
            <AnimatePresence initial={false} custom={direction}>
                <motion.div
                    key={viewKey}
                    custom={direction}
                    variants={slideVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{ type: "tween", duration: 0.28, ease: [0.32, 0.72, 0, 1] }}
                    style={{
                        position: "absolute",
                        width: "100%",
                        top: 0,
                        left: 0,
                    }}
                >
                    {children}
                </motion.div>
            </AnimatePresence>
        </Box>
    );
}
